import React from 'react'
import PropTypes from 'prop-types'
import TextAreaAutosize from 'react-textarea-autosize'

import widgetPreviewImage from './csat-widget-preview.png'

const getWidgetScript = (companyKey, genericToken) => `<div id="simplesat-csat-widget"></div>
<script>
  (function(document) {
    var addWidgetScriptTag = function() {
      var lastScript = Array.prototype.slice.call(document.getElementsByTagName('script')).slice(-1)[0];
      var script = document.createElement('script');
      script.src = 'https://cdn.simplesat.io/js/widget/csat.js';
      lastScript.parentNode.insertBefore(script, lastScript.nextSibling);
      script.addEventListener('load', function() {
        Widget.config({
          showIcon: true,
          dateRange: 90,
          description: 'Live satisfaction score from the past 90 days',
          surveyKey: '${genericToken}',
          companyKey: '${companyKey}'
        });
        Widget.render();
      });
    };
    document.addEventListener('DOMContentLoaded', addWidgetScriptTag);
  })(document);
</script>
`

const onClickArea = (e) => {
  e.target.select()
}

export const CSATWidget = ({ companyKey, genericToken }) => {
  const scriptText = getWidgetScript(companyKey, genericToken)
  return (
    <React.Fragment>
      <h3>CSAT Widget</h3>
      <p>
        The CSAT widget displays the overall satisfaction score from a survey in your Simplesat
        account.
      </p>
      <p>
        <a
          href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings#score-widgets"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Using the CSAT widget
        </a>
      </p>
      <h4>Example Screenshot</h4>
      <img
        className="ui image"
        src={widgetPreviewImage}
        alt="csat widget"
        style={{ maxWidth: '340px' }}
      />
      <h3>Code</h3>
      <p>Place this code wherever you want the plugin to appear on your page.</p>
      <div className="ui form">
        <div className="field">
          <TextAreaAutosize readOnly onClick={onClickArea} value={scriptText} />
        </div>
      </div>
      <h3>Settings</h3>
      <p>You can customize your widget's appearance by modifying the settings listed below.</p>

      <table className="ui celled striped table">
        <thead>
          <tr>
            <th>Setting</th>
            <th>Description</th>
            <th>Default</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>showIcon</code>
            </td>
            <td>
              Option to display a smiley icon. Set <code>true</code> to display, <code>false</code>{' '}
              to hide.
            </td>
            <td>
              <code>true</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>dateRange</code>
            </td>
            <td>The window in number of days to calculate the satisfaction score.</td>
            <td>
              <code>90</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>description</code>
            </td>
            <td>Show description text displayed under the score.</td>
            <td>
              <code>
                Live satisfaction score
                <br />
                from the past 90 days
              </code>
            </td>
          </tr>
          <tr>
            <td>
              <code>surveyKey</code>
            </td>
            <td>The unique key from the survey being displayed.</td>
            <td>
              <code>First CSAT survey created in your account</code>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <em>
          Note:
          <a
            href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings#score-widgets"
            target="_blank"
            rel="noreferrer"
          >
            {' '}
            refer to this documentation
          </a>
          &nbsp;if you'd like to change the survey key
        </em>
      </p>
      <h3>Installation Instructions</h3>
      <p>
        Copy the entire snippet of code above and paste it where you would like it to display on
        your website. The widget is responsive, which means it'll span the entire width of any
        container it's placed in.
      </p>
      <div className="ui message">
        <p>
          Some content management systems might not allow you include JavaScript directly through
          the content editor window. To get around this, you can add the <code>&lt;script&gt;</code>{' '}
          portion of the code in the footer of your website. Then, add{' '}
          <code>&lt;div id="simplesat-csat-widget"&gt;&lt;/div&gt;</code> to any page you'd like the
          widget to display.
        </p>
      </div>
    </React.Fragment>
  )
}
CSATWidget.propTypes = {
  companyKey: PropTypes.string.isRequired,
  genericToken: PropTypes.string,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CSATWidget/index.js